// This is a replication of Set data structure using a Map
// The item it store must have the variable "id"

export default class SetWithID<T extends { id: string }> {
    private mapping: Map<string, T>;

    constructor(items: T[] = []) {
        this.mapping = items.reduce((map, item) => {
            map.set(item.id, item);
            return map;
        }, new Map<string, T>());
    }

    get values(): IterableIterator<T> {
        return this.mapping.values();
    }

    get size(): number {
        return this.mapping.size;
    }

    get isEmpty(): boolean {
        return this.size === 0;
    }

    add = (item: T) => {
        if (!this.mapping.has(item.id)) {
            this.mapping.set(item.id, item);
        }
    };

    delete = (item: T) => {
        this.mapping.delete(item.id);
    };

    has = (item: T): boolean => {
        return this.mapping.has(item.id);
    };

    subtracting = (set: SetWithID<T>): SetWithID<T> => {
        const newSet = new SetWithID<T>();
        this.forEach((item) => {
            if (!set.has(item)) {
                newSet.add(item);
            }
        });
        return newSet;
    };

    clear = () => {
        this.mapping.clear();
    };

    union = (iterator: { forEach: (callback: (item: T) => void) => void }) => {
        iterator.forEach((item) => {
            this.add(item);
        });
    };

    toArray = (): T[] => {
        return Array.from(this.mapping.values());
    };

    map = <R>(mapper: (item: T) => R): R[] => {
        const array: R[] = [];
        this.forEach((item) => {
            array.push(mapper(item));
        });
        return array;
    };

    forEach = (callback: (item: T) => void) => {
        this.mapping.forEach((val) => callback(val));
    };
}
